var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.poptext),expression:"poptext"}],staticClass:"customBtn fa-solid fa-fw fa-triangle-exclamation"})
}
var staticRenderFns = []

export { render, staticRenderFns }